<h1 mat-dialog-title><mat-icon>error_outline</mat-icon> {{title ?? 'Error'}}</h1>
<div mat-dialog-content>
    {{message ?? 'Something went wrong'}}
</div>
<div mat-dialog-actions class="mat-dialog-actions">
    <button type="button" mat-button mat-dialog-close>Close</button>
</div>

